export const setUser = (data) => ({
  type: "LOGIN",
  data,
});
